(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dimitri-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root){
    if (root.dataset.dmfInit) return;
    root.dataset.dmfInit = '1';
    var one = root.dataset.oneOpen === 'true';
    root.addEventListener('click', function (e) {
      var q = e.target.closest('.dmf-q');
      if (!q || !root.contains(q)) return;
      var item = q.closest('.dmf-item');
      var willOpen = !item.classList.contains('is-open');
      if (one && willOpen) {
        root.querySelectorAll('.dmf-item.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          o.querySelector('.dmf-q').setAttribute('aria-expanded', 'false');
        });
      }
      item.classList.toggle('is-open', willOpen);
      q.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  }
  function run(){ document.querySelectorAll('.dmf').forEach(init); }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.dmf').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dimitri-preventa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start(box) {
      if (box.dataset.dmtInit) return;
      var end = Date.parse(box.getAttribute('data-dmt-end'));
      if (isNaN(end)) return;
      box.dataset.dmtInit = '1';

      var els = {};
      ['d', 'h', 'm', 's'].forEach(function (u) { els[u] = box.querySelector('[data-u="' + u + '"]'); });
      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function tick() {
        if (!box.isConnected) { clearInterval(timer); return; }
        var diff = Math.max(0, end - Date.now());
        var s = Math.floor(diff / 1000);
        els.d.textContent = pad(Math.floor(s / 86400));
        els.h.textContent = pad(Math.floor((s % 86400) / 3600));
        els.m.textContent = pad(Math.floor((s % 3600) / 60));
        els.s.textContent = pad(s % 60);
        if (diff === 0) clearInterval(timer);
      }
      tick();
      var timer = setInterval(tick, 1000);
    }

    function init() {
      document.querySelectorAll('.dmt-pre [data-dmt-end]').forEach(start);
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dimitri-stories"] && !Shopify.designMode) return;
  try {
    
(function () {
  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-dmt-stories]').forEach(function (row) {
      var section = row.closest('.dmt-st');
      var viewer = document.querySelector('[data-dmt-viewer]');
      if (!viewer) return;

      var settings = {
        autoplay: viewer.dataset.autoplay === 'true',
      };

      var slides = Array.prototype.slice.call(viewer.querySelectorAll('[data-dmt-slide]'));
      var fills = Array.prototype.slice.call(viewer.querySelectorAll('[data-dmt-progress-fill]'));
      var counter = viewer.querySelector('[data-dmt-counter]');
      var closeBtn = viewer.querySelector('[data-dmt-close]');
      var prevBtn = viewer.querySelector('[data-dmt-prev]');
      var nextBtn = viewer.querySelector('[data-dmt-next]');
      var current = 0;
      var timer = null;

      function stopVideos(){
        slides.forEach(function (slide) {
          var v = slide.querySelector('[data-dmt-video]');
          if (v) { v.pause(); v.currentTime = 0; }
        });
      }

      function resetFills(){
        fills.forEach(function (f) {
          f.classList.remove('is-filling', 'is-done');
          f.style.transition = 'none';
          f.style.width = '0%';
        });
      }

      function show(index){
        clearTimeout(timer);
        current = ((index % slides.length) + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
        if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;

        fills.forEach(function (f, i) {
          f.classList.remove('is-filling');
          f.style.transition = 'none';
          f.style.width = i < current ? '100%' : '0%';
        });

        stopVideos();
        var activeSlide = slides[current];
        var video = activeSlide.querySelector('[data-dmt-video]');
        var duration = parseFloat(activeSlide.dataset.duration || '5') * 1000;

        function advance(){ show(current + 1); }

        if (video) {
          video.currentTime = 0;
          video.play().catch(function(){});
          video.onended = settings.autoplay ? advance : null;
          video.onloadedmetadata = function () {
            animateFill(fills[current], (video.duration || duration / 1000) * 1000);
          };
        } else {
          animateFill(fills[current], duration);
          if (settings.autoplay) timer = setTimeout(advance, duration);
        }
      }

      function animateFill(fill, ms){
        if (!fill) return;
        requestAnimationFrame(function () {
          fill.style.transition = 'width ' + ms + 'ms linear';
          fill.style.width = '100%';
          fill.classList.add('is-filling');
        });
      }

      function open(index){
        viewer.classList.add('is-open');
        viewer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        resetFills();
        show(index);
      }

      function close(){
        viewer.classList.remove('is-open');
        viewer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        clearTimeout(timer);
        stopVideos();
      }

      row.querySelectorAll('[data-dmt-story-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          open(parseInt(btn.dataset.index, 10) || 0);
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', close);
      if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
      viewer.addEventListener('click', function (e) {
        if (e.target === viewer) close();
      });
      document.addEventListener('keydown', function (e) {
        if (!viewer.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["occasion-explorer"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('occasion-explorer')) {

  class OccasionExplorer extends HTMLElement {

    connectedCallback() {

      this._mq = window.matchMedia('(min-width: 750px)');

      this.list = this.querySelector('[data-oe-list]');
      this.media = this.querySelector('[data-oe-media]');
      this.dotsEl = this.querySelector('[data-oe-dots]');

      this.autoclose =
        this.dataset.autoclose === 'true';

      this._onClick =
        (e) => this._click(e);

      this._onSelect =
        (e) => this._select(e);

      this._onScroll =
        () => this._scrollTick();

      this.addEventListener(
        'click',
        this._onClick
      );

      this.addEventListener(
        'shopify:block:select',
        this._onSelect
      );

      this.list?.addEventListener(
        'scroll',
        this._onScroll,
        { passive: true }
      );

      this._mq.addEventListener(
        'change',
        () => this._sync(false)
      );

      this._sync(true);
    }


    disconnectedCallback() {

      this.removeEventListener(
        'click',
        this._onClick
      );

      this.removeEventListener(
        'shopify:block:select',
        this._onSelect
      );

      this.list?.removeEventListener(
        'scroll',
        this._onScroll
      );

    }


    get desktop() {
      return this._mq.matches;
    }


    _sync(initial) {

      const rows = [
        ...this.list.querySelectorAll('.oe__row')
      ];

      this.rows = rows;

      rows.forEach((row, i) => {

        const id = row.dataset.rowId;

        const inRow =
          row.querySelector('.oe-img');

        const inMedia =
          this.media.querySelector(
            `.oe-img[data-owner="${id}"]`
          );

        if (inRow && inMedia) {
          inMedia.remove();
        }

        const img = inRow || inMedia;

        if (img) {

          img.dataset.owner = id;

          if (
            this.desktop &&
            img.parentElement !== this.media
          ) {
            this.media.append(img);
          }

          if (
            !this.desktop &&
            img.parentElement === this.media
          ) {
            row.prepend(img);
          }

        }

        const counter =
          row.querySelector('[data-oe-counter]');

        const label =
          `${i + 1} / ${rows.length}`;

        if (
          counter &&
          counter.textContent !== label
        ) {
          counter.textContent = label;
        }

      });


      this.media
        .querySelectorAll('.oe-img')
        .forEach((img) => {

          if (
            !rows.some(
              (r) =>
                r.dataset.rowId === img.dataset.owner
            )
          ) {
            img.remove();
          }

        });


      if (initial) {

        let opened = null;

        rows.forEach((row) => {

          const want =
            row.dataset.openDefault === 'true' &&
            (!this.autoclose || !opened);

          this._setOpen(row, want);

          if (want && !opened) {
            opened = row;
          }

        });

        this._activeRow =
          opened || rows[0] || null;

      } else {

        rows.forEach((row) => {

          this._setOpen(
            row,
            row.hasAttribute('data-open')
          );

        });

        if (
          !this._activeRow ||
          !rows.includes(this._activeRow)
        ) {
          this._activeRow =
            rows[0] || null;
        }

      }


      if (this._activeRow) {
        this._showImage(this._activeRow);
      }

      this._buildDots();
      this._scrollTick();

    }


    _setOpen(row, open) {

      row.toggleAttribute(
        'data-open',
        open
      );

      row
        .querySelector('[data-oe-trigger]')
        ?.setAttribute(
          'aria-expanded',
          String(open)
        );

    }


    _showImage(row) {

      this._activeRow = row;

      this.media
        .querySelectorAll('.oe-img')
        .forEach((img) => {

          img.toggleAttribute(
            'data-active',
            img.dataset.owner ===
              row.dataset.rowId
          );

        });

    }


    _toggle(row) {

      const willOpen =
        !row.hasAttribute('data-open');

      if (
        willOpen &&
        this.autoclose
      ) {

        this.rows.forEach((r) => {

          if (r !== row) {
            this._setOpen(r, false);
          }

        });

      }

      this._setOpen(
        row,
        willOpen
      );

      if (willOpen) {
        this._showImage(row);
      }

    }


    _slideWidth() {

      return this.rows.length
        ? this.list.scrollWidth /
          this.rows.length
        : 0;

    }


    _buildDots() {

      if (!this.dotsEl) return;

      const n = this.rows.length;

      if (
        this.dotsEl.children.length !== n
      ) {

        this.dotsEl.replaceChildren(
          ...this.rows.map((_, i) => {

            const b =
              document.createElement('button');

            b.type = 'button';
            b.className = 'oe__dot';
            b.dataset.oeDot = String(i);

            b.setAttribute(
              'aria-label',
              `Ir a la diapositiva ${i + 1}`
            );

            return b;

          })
        );

      }

    }


    _scrollTick() {

      if (
        !this.rows?.length ||
        !this.dotsEl
      ) {
        return;
      }

      const w =
        this._slideWidth();

      const idx =
        w
          ? Math.min(
              this.rows.length - 1,
              Math.round(
                this.list.scrollLeft / w
              )
            )
          : 0;

      [
        ...this.dotsEl.children
      ].forEach((d, i) => {

        const current =
          String(i === idx);

        if (
          d.getAttribute(
            'aria-current'
          ) !== current
        ) {

          d.setAttribute(
            'aria-current',
            current
          );

        }

      });

    }


    _click(e) {

      const dot =
        e.target.closest('[data-oe-dot]');

      if (dot) {

        this.list.scrollTo({
          left:
            Number(dot.dataset.oeDot) *
            this._slideWidth(),
          behavior: 'smooth'
        });

        return;
      }


      const trigger =
        e.target.closest(
          '[data-oe-trigger]'
        );

      if (
        trigger &&
        this.desktop
      ) {

        this._toggle(
          trigger.closest('.oe__row')
        );

      }

    }


    _select(e) {

      const row =
        e.target.closest?.('.oe__row');

      if (!row || !this.rows) return;

      if (this.desktop) {

        if (
          !row.hasAttribute('data-open')
        ) {
          this._toggle(row);
        } else {
          this._showImage(row);
        }

      } else {

        const i =
          this.rows.indexOf(row);

        this.list.scrollTo({
          left:
            i * this._slideWidth(),
          behavior: 'auto'
        });

      }

    }

  }

  customElements.define(
    'occasion-explorer',
    OccasionExplorer
  );

}


  } catch(e) { console.error(e); }
})();
})();
